import forge from 'node-forge';

/**
 * AES-GCM decryption function
 */
export async function decryptAesGcm(cipherTextBase64: string): Promise<string> {
  const MASTERKEY = process.env.REACT_APP_DECRYPT_KEY;

  // if (MASTERKEY == null) throw new InvalidOperationException("Encryption service not initialized");
  if (!MASTERKEY) {
    throw new Error('REACT_APP_DECRYPT_KEY is not defined in .env');
  }

  // Validate empty input
  if (
    !cipherTextBase64 ||
    typeof cipherTextBase64 !== 'string' ||
    cipherTextBase64.trim() === ''
  ) {
    return '';
  }

  // Validate Base64 format before attempting to decode
  const base64Regex = /^[A-Za-z0-9+/]*={0,2}$/;
  if (!base64Regex.test(cipherTextBase64.trim())) {
    return '';
  }

  try {
    // var buffer = Convert.FromBase64String(cipherText);
    const bufferBinary = forge.util.decode64(cipherTextBase64.trim());

    // if (buffer.Length < 28) // 12 (nonce) + 16 (tag) = 28 minimum
    //     throw new ArgumentException("Invalid cipher text format");
    if (bufferBinary.length < 28) {
      // Return empty string instead of throwing error for invalid/empty data
      return '';
    }

    // var keyBytes = Convert.FromBase64String(MASTERKEY);
    const keyBinary = forge.util.decode64(MASTERKEY);

    // using var aesGcm = new AesGcm(keyBytes, 16);
    // (16 = tagLength in bytes, which is 128 bits)

    // Extract components
    // var nonce = new byte[12];
    // var tag = new byte[16];
    // var encryptedData = new byte[buffer.Length - 28];
    // var plainText = new byte[encryptedData.Length];
    const NONCE_LENGTH = 12;
    const TAG_LENGTH = 16;
    const ENCRYPTED_DATA_LENGTH = bufferBinary.length - 28;

    // Buffer.BlockCopy(buffer, 0, nonce, 0, 12);
    const nonceBinary = bufferBinary.substring(0, NONCE_LENGTH);

    // Buffer.BlockCopy(buffer, 12, encryptedData, 0, encryptedData.Length);
    const encryptedDataBinary = bufferBinary.substring(
      NONCE_LENGTH,
      NONCE_LENGTH + ENCRYPTED_DATA_LENGTH,
    );

    // Buffer.BlockCopy(buffer, 12 + encryptedData.Length, tag, 0, 16);
    const tagBinary = bufferBinary.substring(
      NONCE_LENGTH + ENCRYPTED_DATA_LENGTH,
      NONCE_LENGTH + ENCRYPTED_DATA_LENGTH + TAG_LENGTH,
    );

    // Create node-forge buffers
    const keyBuffer = forge.util.createBuffer(keyBinary);
    const nonceBuffer = forge.util.createBuffer(nonceBinary);
    const encryptedDataBuffer = forge.util.createBuffer(encryptedDataBinary);
    const tagBuffer = forge.util.createBuffer(tagBinary);

    // Decrypt and verify authentication
    // aesGcm.Decrypt(nonce, encryptedData, tag, plainText);
    const cipher = forge.cipher.createDecipher('AES-GCM', keyBuffer);
    cipher.start({
      iv: nonceBuffer,
      tagLength: 128, // 16 bytes = 128 bits (same as AesGcm(keyBytes, 16))
      tag: tagBuffer,
    });
    cipher.update(encryptedDataBuffer);

    const success = cipher.finish();
    if (!success) {
      // Authentication failed - return empty string instead of throwing error
      console.warn(
        'AES-256-GCM decryption failed: Authentication tag verification failed',
      );
      return '';
    }

    // return Encoding.UTF8.GetString(plainText);
    const plainText = forge.util.decodeUtf8(cipher.output.getBytes());
    return plainText;
  } catch (error) {
    // Log.Error(ex, "Failed to decrypt data using AES-256-GCM");
    // throw new InvalidOperationException("AES-256-GCM decryption failed", ex);
    // In the frontend, we return empty string instead of throwing exception
    // to avoid breaking the application
    console.error('Failed to decrypt data using AES-256-GCM:', error);
    return '';
  }
}
